/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MailingListPreview interface.
 */
export function instanceOfMailingListPreview(value) {
    if (!('configured' in value) || value['configured'] === undefined)
        return false;
    if (!('inSync' in value) || value['inSync'] === undefined)
        return false;
    if (!('subscribers' in value) || value['subscribers'] === undefined)
        return false;
    if (!('expected' in value) || value['expected'] === undefined)
        return false;
    if (!('toAdd' in value) || value['toAdd'] === undefined)
        return false;
    if (!('toRemove' in value) || value['toRemove'] === undefined)
        return false;
    return true;
}
export function MailingListPreviewFromJSON(json) {
    return MailingListPreviewFromJSONTyped(json, false);
}
export function MailingListPreviewFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'configured': json['configured'],
        'inSync': json['in_sync'],
        'subscribers': json['subscribers'],
        'expected': json['expected'],
        'toAdd': json['to_add'],
        'toRemove': json['to_remove'],
        'syncedAt': json['synced_at'] == null ? undefined : (new Date(json['synced_at'])),
        'error': json['error'] == null ? undefined : json['error'],
    };
}
export function MailingListPreviewToJSON(json) {
    return MailingListPreviewToJSONTyped(json, false);
}
export function MailingListPreviewToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'configured': value['configured'],
        'in_sync': value['inSync'],
        'subscribers': value['subscribers'],
        'expected': value['expected'],
        'to_add': value['toAdd'],
        'to_remove': value['toRemove'],
        'synced_at': value['syncedAt'] == null ? undefined : (value['syncedAt'].toISOString()),
        'error': value['error'],
    };
}
